// src/utils/alert.js
import Swal from 'sweetalert2'

const alert = {
  success(message = 'Berhasil!', title = 'Sukses') {
    return Swal.fire({
      icon: 'success',
      title,
      text: message,
      confirmButtonColor: '#28a745'
    })
  },

  error(message = 'Terjadi kesalahan.', title = 'Gagal') {
    return Swal.fire({
      icon: 'error',
      title,
      text: message,
      confirmButtonColor: '#dc3545'
    })
  },

  warning(message = 'Apakah Anda yakin?', title = 'Peringatan') {
    return Swal.fire({
      icon: 'warning',
      title,
      text: message,
      showCancelButton: true,
      confirmButtonColor: '#ffc107',
      cancelButtonColor: '#6c757d',
      confirmButtonText: 'Ya',
      cancelButtonText: 'Batal'
    })
  },

  info(message = '', title = 'Informasi') {
    return Swal.fire({
      icon: 'info',
      title,
      text: message,
      confirmButtonColor: '#0d6efd'
    })
  },

  custom(options) {
    return Swal.fire(options)
  }
}

export default alert
